import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const DownloadImage = forwardRef<SVGSVGElement, IconProps>(({ size = 36 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <g filter="url(#filter0_bd_4955_2902)">
        <mask id="path-1-inside-1_4955_2902" fill="white">
          <path d="M3.65649 4.49976L32.4565 4.49976V33.2998H3.65649L3.65649 4.49976Z" />
        </mask>
        <path
          d="M3.65649 4.49976L32.4565 4.49976V33.2998H3.65649L3.65649 4.49976Z"
          fill="white"
          shapeRendering="crispEdges"
        />
        <path
          d="M3.65649 4.49976V2.99976C2.82807 2.99976 2.15649 3.67133 2.15649 4.49976H3.65649ZM32.4565 4.49976H33.9565C33.9565 3.67133 33.2849 2.99976 32.4565 2.99976V4.49976ZM32.4565 33.2998V34.7998C33.2849 34.7998 33.9565 34.1282 33.9565 33.2998H32.4565ZM3.65649 33.2998H2.15649C2.15649 34.1282 2.82807 34.7998 3.65649 34.7998L3.65649 33.2998ZM3.65649 5.99976L32.4565 5.99976V2.99976L3.65649 2.99976V5.99976ZM30.9565 4.49976V33.2998H33.9565V4.49976H30.9565ZM32.4565 31.7998H3.65649V34.7998H32.4565V31.7998ZM5.15649 33.2998L5.15649 4.49976H2.15649L2.15649 33.2998H5.15649Z"
          fill="white"
          mask="url(#path-1-inside-1_4955_2902)"
        />
        <path d="M30.8975 6.05884V31.7407H5.21558L30.8975 6.05884Z" fill="url(#paint0_linear_4955_2902)" />
        <path d="M5.21558 31.7407V6.05884H30.8975L5.21558 31.7407Z" fill="url(#paint1_linear_4955_2902)" />
      </g>
      <g filter="url(#filter1_dd_4955_2902)">
        <path
          d="M6.59462 16.4339L17.4546 27.9211L28.4091 16.4339L22.4569 16.467C21.7814 8.60943 21.7155 1.99385 26.4569 4.11475C24.1566 -0.352538 20.1402 0.269479 18.2384 1.30831C12.7177 4.32383 11.8873 12.7522 12.0549 16.4035L6.59462 16.4339Z"
          fill="url(#paint2_linear_4955_2902)"
        />
      </g>
      <defs>
        <filter
          id="filter0_bd_4955_2902"
          x="-1.53581"
          y="-0.692552"
          width="39.1847"
          height="39.1847"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2.59615" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_4955_2902" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
          <feBlend mode="normal" in2="effect1_backgroundBlur_4955_2902" result="effect2_dropShadow_4955_2902" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_4955_2902" result="shape" />
        </filter>
        <filter
          id="filter1_dd_4955_2902"
          x="4.59473"
          y="0.560303"
          width="25.8145"
          height="31.3608"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4955_2902" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_4955_2902" result="effect2_dropShadow_4955_2902" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_4955_2902" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_4955_2902"
          x1="18.6986"
          y1="15.7479"
          x2="24.477"
          y2="32.5579"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6D00" />
          <stop offset="1" stopColor="#F8EF6F" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4955_2902"
          x1="5.21558"
          y1="13.1214"
          x2="19.2822"
          y2="17.6741"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#47FF65" />
          <stop offset="1" stopColor="#2C99FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4955_2902"
          x1="17.0113"
          y1="1.5228"
          x2="17.0113"
          y2="15.7616"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B9FF64" />
          <stop offset="1" stopColor="#EBFFE9" />
        </linearGradient>
      </defs>
    </svg>
  )
})

export default DownloadImage
